var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusCircle28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6974 25.6975C31.0532 20.3417 31.0532 11.6583 25.6974 6.30256C20.3416 0.946795 11.6582 0.946796 6.30247 6.30256C0.946704 11.6583 0.946704 20.3417 6.30247 25.6975C11.6582 31.0532 20.3416 31.0532 25.6974 25.6975ZM9.93598 14.7015L13.6505 14.4362C14.0713 14.4061 14.406 14.0713 14.4361 13.6505L14.7014 9.93603C14.7501 9.25476 15.317 8.72692 16 8.72692C16.683 8.72692 17.2499 9.25476 17.2985 9.93602L17.5638 13.6505C17.5939 14.0713 17.9287 14.4061 18.3495 14.4362L22.064 14.7015C22.7452 14.7501 23.2731 15.317 23.2731 16C23.2731 16.683 22.7452 17.2499 22.064 17.2986L18.3495 17.5639C17.9287 17.594 17.5939 17.9287 17.5638 18.3495L17.2985 22.064C17.2499 22.7453 16.683 23.2731 16 23.2731C15.317 23.2731 14.7501 22.7453 14.7014 22.064L14.4361 18.3495C14.406 17.9287 14.0713 17.5939 13.6505 17.5639L9.93598 17.2986C9.25471 17.2499 8.72688 16.683 8.72688 16C8.72688 15.317 9.25471 14.7501 9.93598 14.7015Z",
    fill: "url(#paint0_linear_12038_12938)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12038_12938",
    x1: 2.28564,
    y1: 2.28574,
    x2: 29.7142,
    y2: 29.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle28);
export default __webpack_public_path__ + "static/media/plus_circle_28.e50edb4a.svg";
export { ForwardRef as ReactComponent };